<div class="snackbar-wrapper">
  <button
    type="button"
    class="snackbar-wrapper__close-btn"
    [attr.aria-label]="'GLOBAL.CLOSE_BUTTON' | translate"
    (click)="dismiss($event)"
  >
    <icon set="lucide" name="x" size="16" [strokeWidth]="2.5" />
  </button>

  <a
    href="{{ getNotificationUrl() }}"
    target="_blank"
    (click)="performAction($event)"
  >
    <div class="snackbar-container">
      <div class="snackbar-container__icon">
        <icon set="lucide" name="info" size="30" />
      </div>
      <p
        class="snackbar-container__desc text-label"
        [innerHtml]="notification.content.message"
      ></p>
    </div>
  </a>
</div>
